import { createApi } from "@reduxjs/toolkit/query/react";
import { convertTag, Endpoints } from "services/urls";
import { baseQuery } from "utils/baseQuery";
import { IForms, IFormsQuery } from "../types/forms.types";
import { METHODS } from "../config";
import { apiHelper } from "../utils/apiHelper";
import { IRequests } from "../types/requests.types";
import { APPLICATIONS_TAGS } from "constants/API_TAGS";

const ApplicationApi = createApi({
  reducerPath: "application-api",
  baseQuery: baseQuery(),
  tagTypes: [APPLICATIONS_TAGS.list, APPLICATIONS_TAGS.pending],
  endpoints: (builder) => ({
    // forms list
    formList: builder.query<IForms, IFormsQuery>({
      providesTags: [convertTag(APPLICATIONS_TAGS.list)],
      query: (body) => apiHelper(Endpoints.applications.forms, body),
    }),
    pendingActionsList: builder.query<IRequests, unknown>({
      providesTags: [convertTag(APPLICATIONS_TAGS.pending)],
      query: (body) => apiHelper(Endpoints.requests.pendingActionList, body),
    }),
    formFill: builder.mutation({
      invalidatesTags: [
        convertTag(APPLICATIONS_TAGS.list),
        convertTag(APPLICATIONS_TAGS.pending),
      ],
      query: (body) => ({
        url: Endpoints.applications.fill,
        method: METHODS.post,
        body,
      }),
    }),
    editRequest: builder.mutation({
      invalidatesTags: [
        convertTag(APPLICATIONS_TAGS.list),
        convertTag(APPLICATIONS_TAGS.pending),
      ],
      query: (body) => ({
        url: Endpoints.applications.editRequest,
        method: METHODS.post,
        body,
      }),
    }),
    acceptRequest: builder.mutation({
      invalidatesTags: [
        convertTag(APPLICATIONS_TAGS.list),
        convertTag(APPLICATIONS_TAGS.pending),
      ],
      query: (body) => ({
        url: Endpoints.requests.accept,
        method: METHODS.post,
        body,
      }),
    }),
    rejectRequest: builder.mutation({
      invalidatesTags: [
        convertTag(APPLICATIONS_TAGS.list),
        convertTag(APPLICATIONS_TAGS.pending),
      ],
      query: (body) => ({
        url: Endpoints.requests.reject,
        method: METHODS.post,
        body,
      }),
    }),
    cancelRequest: builder.mutation({
      invalidatesTags: [
        convertTag(APPLICATIONS_TAGS.list),
        convertTag(APPLICATIONS_TAGS.pending),
      ],
      query: (body) => ({
        url: Endpoints.requests.cancel,
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const {
  useFormListQuery,
  useFormFillMutation,
  usePendingActionsListQuery,
  useAcceptRequestMutation,
  useRejectRequestMutation,
  useCancelRequestMutation,
  useEditRequestMutation,
} = ApplicationApi;
export { ApplicationApi };
